import { Component, Input, OnInit } from '@angular/core';
import { BadgeKind, ButtonSize, Icon, IconItem, IconSize } from '@sb/library/base';
import { ButtonBaseComponent } from '../button-base.component';

@Component({
    selector: 'lib-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent extends ButtonBaseComponent implements OnInit {
    @Input() isRound: boolean = false;
    @Input() icon: IconItem | null = Icon.Common.Star;
  

    private _buttonStyleClass: string = "";

    override ngOnInit(): void {
        super.ngOnInit();
        this.iconOnly = true;
        this.SetButtonClass();
    }

    protected override SetButtonClass(): void {
        this._buttonStyleClass = this.kind;

        if (this.disabled) {
            this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-button-disabled');
        }

        if (this.isRound) {
            this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('icon-button-round');
        }

        if (this.active) {
            this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-button-active');
        }

        this.SetSize();
    }

    private SetSize(): void {
        switch (this.size) {
            case ButtonSize.Small:
                this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-icon-button-small');
                this._iconSize = IconSize.ExtraSmall;
                break;
            case ButtonSize.Medium:
                this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-icon-button-medium');
                this._iconSize = IconSize.Small;
                break;
            case ButtonSize.Large:
                this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-icon-button-large');
                this._iconSize = IconSize.Medium;
                break;
            case ButtonSize.XLarge:
                this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-icon-button-xlarge');
                this._iconSize = IconSize.Large;
                break;
            default:
                this._buttonStyleClass = this._buttonStyleClass.concat(' ').concat('sb-icon-button-medium');
        }
    }

    get buttonStyleClass(): string {
        return this._buttonStyleClass;
    }

    get accessibleName(): string | null {
        const iconName = this.icon?.Name.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
        return this.ariaLabel || this.toolTipText || iconName || null;
    }

}
